let cachedScrollBarSize;

export function getScrollBarSize(fresh) {
    if (typeof document === 'undefined') {
        return 0;
    }

    if (fresh || cachedScrollBarSize === undefined) {
        var inner = document.createElement('div');
        inner.style.width = '100%';
        inner.style.height = '200px';
        var outer = document.createElement('div');
        var outerStyle = outer.style;
        outerStyle.position = 'absolute';
        outerStyle.top = '0';
        outerStyle.left = '0';
        outerStyle.pointerEvents = 'none';
        outerStyle.visibility = 'hidden';
        outerStyle.width = '200px';
        outerStyle.height = '150px';
        outerStyle.overflow = 'hidden';
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthContained = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var widthScroll = inner.offsetWidth;

        if (widthContained === widthScroll) {
            widthScroll = outer.clientWidth;
        }

        document.body.removeChild(outer);
        cachedScrollBarSize = widthContained - widthScroll;
    }

    return Math.max(8, cachedScrollBarSize);
}

export function getViewportBoundary(table, { fixed } = {}) {
    let tableBody = table.querySelector('.table-next-body-inner-wrapper'),
        tableHeader = table.querySelector('.table-next-header-wrapper'),
        { top, bottom, left, right } = tableBody.getBoundingClientRect(),
        leftOffset = fixed ? 0 : [...tableHeader.querySelectorAll('th.fixed-left')].reduce((sum, td) => sum + td.offsetWidth, 0),
        rightOffset = fixed ? 0 : [...tableHeader.querySelectorAll('th.fixed-right')].reduce((sum, td) => sum + td.offsetWidth, 0);

    top = Math.max(top, 0);
    left = Math.max(left + leftOffset, 0);
    bottom = Math.min(bottom, document.body.offsetHeight);
    right = Math.min(right - rightOffset, document.body.offsetWidth);

    return { top, bottom, left, right };
}